import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { HeaderVariation } from '@repo/ui/src/types/headerVariation';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Image from '@repo/ui/src/components/Image/New';
import { LinkProps } from '@repo/ui/src/types/link';

interface Props {
  dark?: boolean;
  compatibleWith: Array<{
    image: any;
    link?: LinkProps;
  }>;
}

const CompatibleProducts = ({ dark, compatibleWith }: Props) => {
  const { t } = useTranslation();
  const list = compatibleWith?.filter((item) => item?.link);
  if (!list?.length) {
    return null;
  }
  return (
    <div
      className={classNames('bg-warm-200 p-6', dark ? 'bg-neutral-600 text-white' : 'bg-warm-200')}
    >
      <ToutContent
        forceDivider
        heading={t('productDetailPageContent.compatibleWith', undefined, {
          default: 'Compatible With',
        })}
        align="left"
        headerVariation={{ headerVariation: HeaderVariation.h6 }}
        className="[&_h6]:mt-0"
      />
      <div>
        {list.map((product, i) => (
          <div className="flex gap-3 pb-6 last:pb-0" key={i}>
            {product.image?.image?.url && (
              <Image src={product.image.image.url} width={24} height={24} alt="" />
            )}
            <Anchor {...product.link} className="underline hover:underline hover:text-brand-400" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompatibleProducts;
